<template>
    <div class="panel panel-default panel-dashboard">
        <div class="panel-body">
            <canvas width="800" height="250"/>
        </div>
    </div>
</template>


<script>
    const totalizer = {
        id: 'totalizer',

        beforeUpdate: chart => {
            let totals = {}
            let utmost = null

            chart.data.datasets.forEach((dataset, datasetIndex) => {
                if (chart.isDatasetVisible(datasetIndex) && dataset.yAxisID === 'count') {
                    utmost = datasetIndex

                    dataset.data.forEach((value, index) => {
                        totals[index] = (totals[index] || 0) + value
                    })
                }
            })

            chart.$totalizer = {
                totals: totals,
                utmost: utmost
            }
        }
    }

    import http from '@/http'
    import Chart from "chart.js";
    import datalabels from "chartjs-plugin-datalabels";

    export default {
        props: {
            filters: {
                required: true,
                type: Object
            },

            selectedMetrics: {
                required: true,
                type: Object
            },

            metrics: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                data: null,

                chart: null
            }
        },

        mounted() {
            this.load().then(this.draw)
        },

        watch: {
            filters: {
                deep: true,
                handler: function (value, oldValue) {
                    if (value.category !== oldValue.category || value.user_id !== oldValue.user_id || value.portal_id !== oldValue.portal_id) {
                        this.load().then(this.draw)
                    }
                }
            },

            selectedMetrics: {
                deep: true,
                handler: function () {
                    this.draw()
                }
            }
        },

        methods: {
            load() {
                return http.post('/api/v1/reports/opportunity-by-week', this.filters)
                    .then(response => {
                        this.data = response.data.data
                    })
            },

            draw() {
                if (this.chart) {
                    this.chart.destroy()
                }

                this.chart = new Chart(this.$el.querySelector('canvas').getContext('2d'), {
                    plugins: [datalabels, totalizer],

                    type: 'bar',

                    data: {
                        labels: this.data.map(row => row.week),
                        datasets: [
                            {
                                type: 'line',
                                yAxisID: 'value',
                                fill: false,
                                label: this.metrics.find(metric => metric.value === this.selectedMetrics.first).label,
                                data: this.data.map(row => row[this.selectedMetrics.first]),
                                backgroundColor: '#20aaea',
                                borderColor: '#20aaea'
                            },
                            {
                                type: 'line',
                                yAxisID: 'value',
                                fill: false,
                                label: this.metrics.find(metric => metric.value === this.selectedMetrics.second).label,
                                data: this.data.map(row => row[this.selectedMetrics.second]),
                                backgroundColor: '#8da3a6',
                                borderColor: '#8da3a6'
                            },
                            {
                                label: 'Converted Count',
                                yAxisID: 'count',
                                data: this.data.map(row => row.converted_count),
                                backgroundColor: '#62d26f',
                                borderColor: '#62d26f',
                                fill: false
                            },
                            {
                                label: 'Open Count',
                                yAxisID: 'count',
                                data: this.data.map(row => row.open_count),
                                backgroundColor: '#eec300',
                                borderColor: '#eec300',
                                fill: false
                            },
                            {
                                label: 'Missed Count',
                                yAxisID: 'count',
                                data: this.data.map(row => row.missed_count),
                                backgroundColor: '#e8384f',
                                borderColor: '#e8384f',
                                fill: false
                            }
                        ]
                    },

                    options: {
                        scales: {
                            xAxes: [{
                                stacked: true
                            }],
                            yAxes: [
                                {
                                    id: 'count',
                                    stacked: true,
                                    position: 'left',
                                    ticks: {
                                        beginAtZero: true
                                    }
                                },
                                {
                                    id: 'value',
                                    stacked: false,
                                    position: 'right',
                                    ticks: {
                                        beginAtZero: true,
                                        callback: value => this.$options.filters.price(value)
                                    }
                                }
                            ]
                        },

                        layout: {
                            padding: {
                                top: 25
                            }
                        },

                        legend: {
                            position: 'bottom'
                        },

                        plugins: {
                            datalabels: {
                                anchor: 'end',
                                align: 'end',
                                formatter: (value, ctx) => ctx.chart.$totalizer.totals[ctx.dataIndex],
                                display: (ctx) => ctx.datasetIndex === ctx.chart.$totalizer.utmost
                            }
                        },

                        onClick: (event, elements) => {
                            if (elements.length) {
                                this.$emit('update:filters', {
                                    ...this.filters,
                                    conversion_expected_from: this.data[elements[0]['_index']].start_date,
                                    conversion_expected_to: this.data[elements[0]['_index']].end_date
                                })
                            }
                        },

                        tooltips: {
                            callbacks: {
                                label: (t, d) => {
                                    if (t.datasetIndex === 0 || t.datasetIndex === 1) {
                                        return d.datasets[t.datasetIndex].label + ': ' + this.$options.filters.price(d.datasets[t.datasetIndex].data[t.index])
                                    }

                                    return d.datasets[t.datasetIndex].label + ': ' + d.datasets[t.datasetIndex].data[t.index]
                                }
                            }
                        }
                    }
                })
            }
        }
    }
</script>
